<script>
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";

export default {
    page: {
        title: "Import Images",
        meta: [{ name: "description", content: appConfig.description }]
    },

    mounted(){


    },
    
    data() {
        return {

            imagesZipFile: null,
            imagesZipFileImportInProgress: false,
            importImagesFailures: null,
        }
    }, 
    methods:{

        onImagesUpload(){
            if(!this.imagesZipFile) {
                return;
            }

            this.importImagesFailures = null;
            this.imagesZipFileImportInProgress = true;
            const fd = new FormData();
            fd.append('file', this.imagesZipFile, this.imagesZipFile.name)
            ItemsApi.importImages(fd).then((failures) =>{
                  this.imagesZipFileImportInProgress = false;

                  if (failures) {
                      this.importImagesFailures = failures;
                  }
                  this.imagesZipFile=null
              }
            ).finally(() => {
              this.imagesZipFileImportInProgress = false;
              this.imagesZipFile=null
            })
        },

    },
}
</script>
<template>
  <!-- Images import -->
  <div class="row p-sm-4">
      <div class="col-lg-12">
        <div class="row pt-sm-4">
            <div class="col-12">
                <h5 class="text-primary font-size-16"><i class="fas fa-file-archive  mr-2"/><strong>Importer des images</strong></h5>
            </div>
        </div>

        <div class="row pt-4 pb-4" >
        
            <div class="col-10  col-sm-8"> 
                <div class="custom-file custom-input-file-width" style="float:left;"> 
                        <b-form-file
                            v-model="imagesZipFile"
                            ref="fileUpload"
                            placeholder="Aucun fichier sélectionné"
                            drop-placeholder="Placez le fichier ZIP ici"
                        ></b-form-file>
                </div>
            </div>
        
            <div class="col-2 col-sm-1 ">
                <p class="pt-2">
                    <a  title="Importer un fichier ZIP avec des images au format <REF>.png" href="javascript:void(0);" class="action-icon text-primary ml-4 ml-sm-2 ml-md-4" >
                        <i class="fas fa-question-circle font-size-22 align-middle"></i>
                    </a>
                </p>
            </div>

            <div class="col-12 col-sm-3">
                <b-button variant="primary" style="width:100%" @click="onImagesUpload"  :disabled="!imagesZipFile || imagesZipFileImportInProgress">                        
                    <b-spinner small :class="this.imagesZipFileImportInProgress ? 'mr-2' : 'd-none'"></b-spinner>
                    <span class="font-weight-bold font-size-14">Importer {{imagesZipFile ? '['+ this.imagesZipFile.name + ']' : ''}}</span>
                </b-button>
            </div>

        </div>

        <div v-if="importImagesFailures" class="row">
            <div class="col-12">
                <div class="font-weight-bold text-danger font-size-14">L'upload des fichiers suivants a échoué : 
                    <span class="text-dark font-weight-normal font-size-14 pt-4">{{ importImagesFailures }}</span>
                </div>
            </div>
        </div>
      </div>
    </div>

</template>